import { Box } from "@mui/material";
import DynamicInput from "../feilds/dynamic-input";
import BlackButtonComponent from "./../../../components/shared/buttons/black-button-component";
import { useSelector } from "react-redux";
import { RootState } from "store";

const BankDetailsForm = ({
  formik,
  submit,
  loading,
}: {
  formik: any;
  submit: () => void;
  loading: boolean;
}) => {
  const bankDetails = useSelector(
    (state: RootState) => state.merchantForm.bankDetails
  ) as any;

  return (
    <Box>
      <DynamicInput
        formik={formik}
        name="accountName"
        label="Name on Account"
        value={bankDetails.beneficiary_name}
        type="text"
        placeholder="Enter the name on the account"
        disabled
      />
      <DynamicInput
        formik={formik}
        name="accountNumber"
        label="Account Number"
        type="text"
        value={bankDetails?.accountNumber}
        placeholder="Enter the account number"
        disabled
      />
      <DynamicInput
        formik={formik}
        name="branchName"
        label="Branch Name"
        type="text"
        value={bankDetails?.ifsc_info?.BRANCH}
        placeholder="Enter the branch name"
        disabled
      />
      <DynamicInput
        formik={formik}
        name="bankName"
        label="Bank Name"
        type="text"
        value={bankDetails?.ifsc_info?.BANK}
        placeholder="Enter the bank name"
        disabled
      />

      <Box textAlign="right" display="flex" justifyContent="end" columnGap={2}>
        <BlackButtonComponent
          onClick={submit}
          btnText={loading ? "Loading..." : "Submit"}
          sx={{
            padding: "6px 40px",
            marginTop: "10px",
          }}
          disabled={loading}
        />
      </Box>
    </Box>
  );
};

export default BankDetailsForm;
